import { graphql } from '../../../../globals/api/requests';

export const verifyEmail = (userId, email, token) =>
  graphql(
    `
      mutation updateEmail($userId: Int!, $email: String!, $token: String!) {
        updateEmail(userId: $userId, email: $email, token: $token) {
          success
        }
      }
    `,
    {
      userId,
      email,
      token,
    },
    { method: 'PATCH' }
  );

export default {
  verifyEmail,
};
